/**
 * Query key factory for Reviews module
 * Provides centralized query key management for React Query
 */

export const reviewKeys = {
  all: ['reviews'] as const,

  // Review list keys (prefix for invalidation by SKU)
  lists: (sku?: string) =>
    sku ? ([...reviewKeys.all, 'list', sku] as const) : ([...reviewKeys.all, 'list'] as const),

  // Review list with pagination params (for specific queries)
  list: (sku: string, pageSize?: number, currentPage?: number) =>
    [...reviewKeys.lists(sku), { pageSize, currentPage }] as const,

  // Rating metadata keys
  ratings: () => [...reviewKeys.all, 'ratings'] as const,
}
